import React, { useState } from "react";
import { Box, Typography, Grid, Paper, TextField, Button, CircularProgress } from "@mui/material";
import to from "await-to-js";
import { axiosWithAuth } from "../plugins/axios";
import Papa from "papaparse";

const apiUrl = process.env.REACT_APP_PIPELINE_API;

const DownloadQuizByCohort = () => {
  const [cohortId, setCohortId] = useState("");
  const [loading, setLoading] = useState(false);

  const handleDownload = async () => {
    if (!cohortId) {
      alert("Please enter a Cohort ID!");
      return;
    }

    setLoading(true);

 
    const [err, response] = await to(
      axiosWithAuth(`${apiUrl}cohortConfiguration/downloadQuiz/${cohortId}`, {}, "get")
    );

    if (err) {
      console.error("Error fetching quizzes:", err);
      alert("Failed to fetch quizzes. Please try again.");
      setLoading(false);
      return;
    }

    const quizzes = response.data;

    if (!quizzes.length) {
      alert("No quizzes found for this Cohort ID.");
      setCohortId("")
      setLoading(false);
      return;
    }

   
    const csv = Papa.unparse(quizzes, {
      quotes: true, 
    });

    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.setAttribute("download", `quizzes_cohort_${cohortId}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    setCohortId("");

    setLoading(false);

  };

  return (
    <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
      <Box flexGrow={1} p={4} maxWidth={600}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Paper elevation={2} sx={{ p: 4, textAlign: "center" }}>
              <Typography variant="h5" fontWeight={600}>
                Download Quiz By Cohort
              </Typography>
              <Box mt={3}>
                <TextField
                  fullWidth
                  label="Enter Cohort ID"
                  placeholder="e.g. 12345"
                  variant="outlined"
                  value={cohortId}
                  onChange={(e) => setCohortId(e.target.value)}
                  sx={{ mb: 2 }}
                />
                <Button
                  fullWidth
                  variant="contained"
                  color="primary"
                  onClick={handleDownload}
                  disabled={loading}
                >
                  {loading ? <CircularProgress size={24} /> : "Download CSV"}
                </Button>
              </Box>
            </Paper>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default DownloadQuizByCohort;
